module.exports = __webpack_public_path__ + "img/calendar.bc6b5d6e.svg";